// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0;
    padding: 0;
}

:root {
    --mainColor: #0e0635;
    --mainColorLight: #5767aa;
    --secondaryColor: #97a7ff;
    --textColor: #ffffff;
    --topBarColor: #ebae5e;
}

/* Top Bar */
.top-bar {
    position: fixed;
    top: 0;
    right: 0;
    left: 80px;
    height: 90px;
    background-color: var(--topBarColor);
    z-index: 99;
    border-bottom: 2px solid black;
    transition: left 0.3s ease;
}

header.expanded + .top-bar {
    left: 250px;
    transition: left 0.3s ease;
}

.top-bar-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding-right: 20px;
    position: relative;
}

.username {
    position: absolute;
    left: 120px;
    top: 50%;
    transform: translateY(-50%);
}

.top-bar-buttons {
    display: flex;
    gap: 10px;
    margin-left: 20px;
}

.top-bar-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background-color: var(--mainColor);
    color: var(--textColor);
    cursor: pointer;
    transition: 0.3s;
}

.top-bar-btn:hover {
    background-color: var(--mainColorLight);
}

.phone-number {
    color: var(--mainColor);
    font-weight: bold;
    margin-left: auto;
}

/* Header */
header {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: var(--mainColor);
    color: var(--textColor);
    padding: 2rem 1rem;
    transition: width 0.3s ease;
    z-index: 100;
}

header.expanded {
    width: 250px;
}

header.expanded + .top-bar {
    left: 250px;
}

header.collapsed {
    width: 80px;
}

.nav-links {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 40px;
}

nav a {
    color: var(--textColor);
    text-decoration: none;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.collapsed nav a {
    font-size: 1.5rem;
}

nav a:hover {
    color: var(--secondaryColor);
}

header .nav-btn {
    padding: 5px;
    cursor: pointer;
    background: transparent;
    border: none;
    outline: none;
    color: var(--textColor);
    visibility: hidden;
    opacity: 0;
    font-size: 1.8rem;
}

nav a.active {
    color: var(--secondaryColor);
}

.toggle-btn {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    cursor: pointer;
    background: transparent;
    border: none;
    outline: none;
    color: var(--textColor);
    font-size: 1.2rem;
    transition: 0.3s;
}

.toggle-btn:hover {
    color: var(--secondaryColor);
}

/* Add margin for all React pages */
#root > div:not(.top-bar):not(header) {
    margin-left: 90px;
    transition: margin-left 0.3s ease;
}

#root > div:not(.top-bar):not(header).expanded {
    margin-left: 250px;
}

.container-about-info {
    border: solid 2px #121212;
    transition: transform 50ms;
    width: 90%;
    max-width: 1200px;
    min-width: 320px;
    font-family: IBM Plex Mono;
    padding: 20px;

    background: rgb(255, 255, 255);
}






















/* Стилі для селектора мови */
.language-selector {
    position: relative;
    display: inline-block;
}

.language-btn {
    background-color: #34495e;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    min-width: 50px;
    transition: background-color 0.3s;
}

.language-btn:hover {
    background-color: #4a6572;
}

.language-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    z-index: 1000;
    min-width: 70px;
}

.language-option {
    display: block;
    width: 100%;
    padding: 8px 15px;
    border: none;
    background: none;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    color: #2c3e50;
    transition: background-color 0.3s;
}

.language-option:hover {
    background-color: #f8f9fa;
}

.language-option.active {
    background-color: #3498db;
    color: white;
}


/* Адаптація для мобільних пристроїв */
@media (max-width: 768px) {
    .top-bar-content {
        flex-direction: column;
        gap: 10px;
        height: auto;
    }
    
    .phone-number {
        order: 3;
        font-size: 12px;
    }
    
    .top-bar-buttons {
        order: 2;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,WAAW;IACX,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,kCAAkC;IAClC,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,mCAAmC;AACnC;IACI,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;;IAEb,8BAA8B;AAClC;;;;;;;;;;;;;;;;;;;;;;;AAuBA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;;AAGA,sCAAsC;AACtC;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;700&display=swap\");\r\n\r\nbody {\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n:root {\r\n    --mainColor: #0e0635;\r\n    --mainColorLight: #5767aa;\r\n    --secondaryColor: #97a7ff;\r\n    --textColor: #ffffff;\r\n    --topBarColor: #ebae5e;\r\n}\r\n\r\n/* Top Bar */\r\n.top-bar {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    left: 80px;\r\n    height: 90px;\r\n    background-color: var(--topBarColor);\r\n    z-index: 99;\r\n    border-bottom: 2px solid black;\r\n    transition: left 0.3s ease;\r\n}\r\n\r\nheader.expanded + .top-bar {\r\n    left: 250px;\r\n    transition: left 0.3s ease;\r\n}\r\n\r\n.top-bar-content {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    height: 100%;\r\n    padding-right: 20px;\r\n    position: relative;\r\n}\r\n\r\n.username {\r\n    position: absolute;\r\n    left: 120px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.top-bar-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-left: 20px;\r\n}\r\n\r\n.top-bar-btn {\r\n    padding: 8px 16px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    background-color: var(--mainColor);\r\n    color: var(--textColor);\r\n    cursor: pointer;\r\n    transition: 0.3s;\r\n}\r\n\r\n.top-bar-btn:hover {\r\n    background-color: var(--mainColorLight);\r\n}\r\n\r\n.phone-number {\r\n    color: var(--mainColor);\r\n    font-weight: bold;\r\n    margin-left: auto;\r\n}\r\n\r\n/* Header */\r\nheader {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background-color: var(--mainColor);\r\n    color: var(--textColor);\r\n    padding: 2rem 1rem;\r\n    transition: width 0.3s ease;\r\n    z-index: 100;\r\n}\r\n\r\nheader.expanded {\r\n    width: 250px;\r\n}\r\n\r\nheader.expanded + .top-bar {\r\n    left: 250px;\r\n}\r\n\r\nheader.collapsed {\r\n    width: 80px;\r\n}\r\n\r\n.nav-links {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    margin-top: 40px;\r\n}\r\n\r\nnav a {\r\n    color: var(--textColor);\r\n    text-decoration: none;\r\n    padding: 0.5rem 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.collapsed nav a {\r\n    font-size: 1.5rem;\r\n}\r\n\r\nnav a:hover {\r\n    color: var(--secondaryColor);\r\n}\r\n\r\nheader .nav-btn {\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    background: transparent;\r\n    border: none;\r\n    outline: none;\r\n    color: var(--textColor);\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    font-size: 1.8rem;\r\n}\r\n\r\nnav a.active {\r\n    color: var(--secondaryColor);\r\n}\r\n\r\n.toggle-btn {\r\n    position: absolute;\r\n    bottom: 20px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    background: transparent;\r\n    border: none;\r\n    outline: none;\r\n    color: var(--textColor);\r\n    font-size: 1.2rem;\r\n    transition: 0.3s;\r\n}\r\n\r\n.toggle-btn:hover {\r\n    color: var(--secondaryColor);\r\n}\r\n\r\n/* Add margin for all React pages */\r\n#root > div:not(.top-bar):not(header) {\r\n    margin-left: 90px;\r\n    transition: margin-left 0.3s ease;\r\n}\r\n\r\n#root > div:not(.top-bar):not(header).expanded {\r\n    margin-left: 250px;\r\n}\r\n\r\n.container-about-info {\r\n    border: solid 2px #121212;\r\n    transition: transform 50ms;\r\n    width: 90%;\r\n    max-width: 1200px;\r\n    min-width: 320px;\r\n    font-family: IBM Plex Mono;\r\n    padding: 20px;\r\n\r\n    background: rgb(255, 255, 255);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Стилі для селектора мови */\r\n.language-selector {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.language-btn {\r\n    background-color: #34495e;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 15px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n    min-width: 50px;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.language-btn:hover {\r\n    background-color: #4a6572;\r\n}\r\n\r\n.language-dropdown {\r\n    position: absolute;\r\n    top: 100%;\r\n    right: 0;\r\n    background-color: white;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n    z-index: 1000;\r\n    min-width: 70px;\r\n}\r\n\r\n.language-option {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 8px 15px;\r\n    border: none;\r\n    background: none;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n    color: #2c3e50;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.language-option:hover {\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.language-option.active {\r\n    background-color: #3498db;\r\n    color: white;\r\n}\r\n\r\n\r\n/* Адаптація для мобільних пристроїв */\r\n@media (max-width: 768px) {\r\n    .top-bar-content {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        height: auto;\r\n    }\r\n    \r\n    .phone-number {\r\n        order: 3;\r\n        font-size: 12px;\r\n    }\r\n    \r\n    .top-bar-buttons {\r\n        order: 2;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
